import type { Region } from "@/types/geodata";

export function HoverCard({ region }: { region?: Region }) {
  if (!region) return null;

  return (
    <div className="absolute bottom-24 left-4 z-20 max-w-sm rounded-md border border-white/15 bg-black/70 p-4 shadow-2xl backdrop-blur">
      <div className="flex items-start justify-between gap-4">
        <div>
          <p className="text-xs uppercase text-muted-foreground">{region.country}</p>
          <h2 className="text-xl font-semibold">{region.name}</h2>
        </div>
        <span className="rounded-sm bg-red-500/20 px-2 py-1 text-sm text-red-100">
          {region.pressureIndex}
        </span>
      </div>
      <p className="mt-3 text-sm text-muted-foreground">{region.summary}</p>
      <p className="mt-3 text-xs text-amber-200">
        {region.populationAffected.toLocaleString()} people affected
      </p>
    </div>
  );
}
